import { Injectable } from '@angular/core';
import {
  RomexisV2ResolvePatientCommand,
  RomexisV2ToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import { Practice } from '@principle-theorem/principle-core';
import {
  BridgeDeviceStatus,
  IBridgeDevice,
  IPatient,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { BasicDialogService } from '@principle-theorem/ng-shared';
import { asReffable, Firestore, WithRef } from '@principle-theorem/shared';
import { BridgeCommandsService } from '../../../bridge-commands.service';

@Injectable()
export class RomexisV2FeatureService {
  constructor(
    private _bridgeCommands: BridgeCommandsService,
    private _dialog: BasicDialogService
  ) {}

  async openPatient(
    patient: WithRef<IPatient>,
    device: WithRef<IBridgeDevice>
  ): Promise<void> {
    if (!device.deviceId) {
      return;
    }

    const masterDevice = await this._findMasterDevice(device);
    if (!masterDevice) {
      await this._alertNoMaster();
      return;
    }

    const resolvePatientCommand: RomexisV2ResolvePatientCommand = {
      type: RomexisV2ToDeviceCommand.ResolvePatient,
      data: { patient, targetDeviceId: device.deviceId },
    };
    await this._bridgeCommands.sendCommand(
      resolvePatientCommand,
      masterDevice.ref
    );
  }

  private async _findMasterDevice(
    device: WithRef<IBridgeDevice>
  ): Promise<WithRef<IBridgeDevice> | undefined> {
    const practiceRef = Firestore.getParentDocRef<IPractice>(device.ref);
    const bridgeDevices = await Firestore.getDocs(
      Practice.bridgeDeviceCol(asReffable(practiceRef))
    );
    return bridgeDevices.find(
      (bridgeDevice) =>
        bridgeDevice.status === BridgeDeviceStatus.Active &&
        !!bridgeDevice.settings?.romexisV2?.enabled &&
        !!bridgeDevice.settings.romexisV2.isMaster
    );
  }

  private async _alertNoMaster(): Promise<void> {
    await this._dialog.alert({
      title: 'No Main Bridge Device',
      prompt: [
        'The Romexis main bridge device is offline or not set up.',
        'Patients cannot be opened in Romexis until the main bridge is available.',
      ],
      submitLabel: 'Close',
    });
  }
}
